import useLive from "./useLive";

/**
 * Backwards-compatible alias for previous components.
 * Returns the `listed` rows from the live singleton.
 */
export default function useLiveBoard() {
  const { listed } = useLive();
  return listed;
}
